import { createContext, useContext } from 'react';
import { MediaContextValue } from './media.types';

export const MediaContext = createContext<MediaContextValue | null>(null);

export const useMedia = () => {
  const ctx = useContext(MediaContext);

  if (!ctx) {
    throw new Error(
      'Media compound components must be used within <Media.Root>'
    );
  }

  return ctx;
};
